import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../msalConfig";
import Button from "../../components/Button/Button";
import "./Login.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import eyLogo from "../../assets/images/ey-logo-white.svg";
import { useAppDispatch } from "../../store/hooks";
import {
  getUserLogout,
  resetUserLogout,
} from "../../store/slices/UserLogoutSlice";
import {
  clearExplicitLogout,
  notifySessionContinueAcrossTabs,
  removeAccessTokenFromLocal,
  setAccessTokenInLocal,
  getAccessTokenFromLocal,
} from "../../utils/common";
import Loader from "../../components/Loader";

interface LoginProps {
  verfiyLogin?: boolean;
  setVerifyLogin?: React.Dispatch<React.SetStateAction<boolean>>;
  setLoginError?: React.Dispatch<React.SetStateAction<boolean>>;
  loginInProgress?: boolean;
  setIsLoginInprogress?: React.Dispatch<React.SetStateAction<boolean>>;
}
const Login = ({
  setVerifyLogin,
  setLoginError,
  loginInProgress,
  setIsLoginInprogress,
}: LoginProps) => {
  const ACCESS_TOKEN = getAccessTokenFromLocal();
  const [error, setError] = React.useState("");
  const { instance } = useMsal();
  const isLoginError = useSelector(
    (state: RootState) => state.UserLogoutSlice.isLoginError,
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (isLoginError) {
      setError("Login failed. Please try again.");
    }
  }, [isLoginError]);

  const handleLoginClick = async () => {
    notifySessionContinueAcrossTabs();
    if (isLoginError) {
      setIsLoginInprogress?.(false);
      if (!ACCESS_TOKEN || ACCESS_TOKEN === "" || ACCESS_TOKEN === null) {
        const loginResponse = await instance.loginPopup(loginRequest);
        setAccessTokenInLocal(loginResponse?.accessToken || "");
      }
      await dispatch(getUserLogout());
    }
    clearExplicitLogout();
    removeAccessTokenFromLocal();
    dispatch(resetUserLogout());
    const redirectTo = sessionStorage.getItem("redirectTo");
    sessionStorage.setItem("redirectTo", redirectTo || "/");
    setLoginError?.(false);
    setVerifyLogin?.(false);

    if (
      typeof window.SN_CSM_EC !== "undefined" &&
      typeof window.SN_CSM_EC.show === "function" &&
      typeof window.SN_CSM_EC.onLogin === "function"
    ) {
      window.SN_CSM_EC.onLogin();
      window.SN_CSM_EC.show(true);
    }
  };

  // ensure that the service now messenger is closed in Login Window
  if (
    typeof window.SN_CSM_EC !== "undefined" &&
    typeof window.SN_CSM_EC?.close === "function"
  ) {
    window.SN_CSM_EC.close();
  }

  if (loginInProgress) {
    return (
      <div className="login-page">
        <Loader />
      </div>
    );
  }

  // login page always in dark theme only
  return (
    <div className="motif-theme-dark" motif-theme="dark">
      <div className="login-page">
        <div className="login-content">
          <div>
            <img src={eyLogo} alt="Ey Logo" />
          </div>
          <div className="sign-in-btn">Sign In</div>
          <MotifErrorMessage
            aria-live="assertive"
            role="alert"
            id="aria-error-example"
          >
            {error !== "" ? error : ""}
          </MotifErrorMessage>

          <div className="login-btn-grid">
            <Button
              label="Login"
              variant="primary"
              className="login-btn"
              onClickHandler={handleLoginClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
